import PropTypes from "prop-types"
import React from "react"

import BoatPreviewLink from "src/components/BoatPreviewLink"

import { inchesToFeet } from "src/utils/UnitConversion"

const BoatSection = ({ boat }) => {
  const {
    make,
    model,
    year,
    lengthOverall,
    beam,
    height,
    draw,
    photoUrl,
    hullIdentification,
  } = boat

  const dimensions = [
    lengthOverall && `${inchesToFeet(lengthOverall)}' LOA`,
    beam && `${inchesToFeet(beam)}' Beam`,
    height && `${inchesToFeet(height)}' Height`,
    draw && `${inchesToFeet(draw)}' Draft`,
  ]
    .filter(Boolean)
    .join(" · ")

  return (
    <div>
      <h2 className="m-0 text-xxs uppercase tracking-wide text-gray-500">
        Boat
      </h2>
      <div className="mt-1 flex gap-4">
        <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-lg bg-blue-50">
          {photoUrl ? (
            <img
              alt={boat.name}
              className="h-full w-full object-cover"
              src={photoUrl}
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-blue-400">
              <i className="icon icon-md-directions-boat text-2xl" />
            </div>
          )}
        </div>
        <div className="flex flex-col justify-start gap-0.5">
          <BoatPreviewLink boat={boat} />
          {(year || make || model) && (
            <div className="text-sm text-gray-600">
              {[year, make, model].filter(Boolean).join(" ")}
            </div>
          )}
          {dimensions && (
            <div className="text-sm text-gray-500">{dimensions}</div>
          )}
          {hullIdentification && (
            <div className="text-sm text-gray-500">
              HIN: {hullIdentification}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

BoatSection.propTypes = {
  boat: PropTypes.shape({
    name: PropTypes.string.isRequired,
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
    lengthOverall: PropTypes.number,
    beam: PropTypes.number,
    height: PropTypes.number,
    draw: PropTypes.number,
    photoUrl: PropTypes.string,
    hullIdentification: PropTypes.string,
    registrationNumber: PropTypes.string,
    registrationStatus: PropTypes.oneOf(["active", "expired", "missing"]),
    insuranceStatus: PropTypes.oneOf(["active", "expired", "missing"]),
    url: PropTypes.string.isRequired,
  }).isRequired,
}

export default BoatSection
